
<template>
  <div>
    <div class="type">
      <el-tabs v-model="activeName" class="type-style" type="card" @tab-click="handleClick">
        <el-tab-pane v-if="codeData.indexOf('363') != -1" label="未采纳稿件" name="first"></el-tab-pane>
        <el-tab-pane v-if="codeData.indexOf('371') != -1" label="已采纳稿件" name="second"></el-tab-pane>
        <el-tab-pane v-if="codeData.indexOf('375') != -1" label="评分标准" name="third"></el-tab-pane>
      </el-tabs>
       <noAdoptionManuscript  v-if="type == 1 && codeData.indexOf('363') != -1"></noAdoptionManuscript>
      <adoptionManuscript  v-if="type == 2 && codeData.indexOf('371') != -1"></adoptionManuscript>
      <scoringCriteria  v-if="type == 3 && codeData.indexOf('375') != -1"></scoringCriteria>
    </div>
  </div>
</template>

<script>
import adoptionManuscript from './adoption_manuscript.vue';
import noAdoptionManuscript from './no_adoption_manuscript.vue';
import scoringCriteria from './scoring_criteria.vue';
export default {
  data(){
    return {
      type:1,
      codeData:[],
      activeName:'first',
      numData:{},
    }
  },
  components:{
    adoptionManuscript,
    noAdoptionManuscript,
    scoringCriteria,
  },
  mounted(){
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    if(this.codeData.indexOf('363') == -1 && this.codeData.indexOf('375') == -1){
        this.type = 3;
        this.activeName = 'third'
        return;
    }else if(this.codeData.indexOf('363') == -1){
        this.type = 2;
        this.activeName = 'second';
        return;
    }
  },
    methods:{
      changeType(type) {
        this.type = type;
      },
      handleClick(){
        if(this.activeName == 'first'){
            this.type = 1;
        }
         if(this.activeName == 'second'){
            this.type = 2;
        }
        if(this.activeName == 'third'){
            this.type = 3;
        }
      }
    }
}
</script>

<style lang="less" scoped>
  .log-box {
  //border-bottom: solid 1px #dcdfe6;
  display: flex;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 24px;
  .log {
    padding: 10px 20px;
    border-top: solid 2px #dcdfe6;
    border-left: solid 2px #dcdfe6;
    cursor: pointer;
    border-bottom: solid 2px #dcdfe6;
  }
  .log:last-child {
    border-right: solid 2px #dcdfe6;
    border-top-right-radius: 10px;
  }
  .log:first-child {
    border-top-left-radius: 10px;
  }
}
.dir {
  height: 2px;
  background: #dcdfe6;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: -2px;
}
.type-style{
  padding: 24px;
  padding-bottom: 6px;
}
/deep/ .el-tabs__item.is-active{
    color: #176DE6;
}
/deep/ .el-tabs__item{
  color: rgba(102, 111, 128, 1);
  font-size: 14px;
  font-family: Roboto;
}
.push-box {
            width: 8px;
            height: 8px;
            background-color: rgba(245, 108, 108, 1);
            text-align: center;
            border-radius: 50%;
            position: absolute;
            right: 10px;
            top: 10px;
          }
</style>